import { render, staticRenderFns } from "./review_check.vue?vue&type=template&id=8b7d4702&scoped=true&"
import script from "./review_check.vue?vue&type=script&lang=js&"
export * from "./review_check.vue?vue&type=script&lang=js&"
import style0 from "./review_check.vue?vue&type=style&index=0&id=8b7d4702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7d4702",
  null
  
)

export default component.exports